import { createSlice } from "@reduxjs/toolkit";

const moviesSlice= createSlice({
    name:"movies",
    initialState:{
        nowPlayingMovies : null,
    },
    reducers:{
        addNowPlayingMovies: (state,action)=>{
            state.nowPlayingMovies= action.payload;
        },
        addTrailerVideo: (state, action) => {
            state.trailerVideo = action.payload;
          },
          addPopularMovies: (state, action) => {
            state.popularMovies = action.payload;
          },
          addTopRatedMovies: (state, action) => {
            state.TopRatedMovies = action.payload;
          },
          addUpcomingMovies: (state, action) => {
            state.UpcomingMovies = action.payload;
          },
    }
     
});

export const{addNowPlayingMovies, addTrailerVideo, addPopularMovies, addTopRatedMovies, addUpcomingMovies}= moviesSlice.actions; 

export default moviesSlice.reducer;
export const moviesReducer = moviesSlice.reducer;